/**
 * Converts a title string to a clean URL-friendly slug
 * @param {string} text 
 * @returns {string} slugified text
 */
export const generateSlug = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD') // normalization for accents
    .replace(/[\u0300-\u036f]/g, '') // remove accent markings
    .trim()
    .replace(/\s+/g, '-') // spaces to dashes
    .replace(/[^\w-]+/g, '') // remove non-word chars
    .replace(/--+/g, '-'); // collapse multiple dashes
};
